import React, { useState } from 'react'
import "./LoginForm.css"
import { Col, Container, Row, Spinner, } from 'react-bootstrap'
import logo from "../../assets/Picture1.png"
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { loginMethod } from '../../hook/auth'
import { toast, ToastContainer } from 'react-toastify'
import { apiUrl } from '../../constant/apiUrl'
function LoginForm() {
  const userinfo = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.username) {
      newErrors.username = "اسم المستخدم مطلوب";
    }
    if (!formData.password) {
      newErrors.password = "كلمة المرور مطلوبة";
    } else if (formData.password.length < 6) {
      newErrors.password = "كلمة المرور يجب أن تكون 6 أحرف على الأقل";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true)

    try {
      const response = await axios.post(`${apiUrl}/user/auth/login`, formData);
      // setMessage("تم تسجيل الدخول بنجاح!");
      console.log(response.data.data);
      setLoading(false)

      dispatch(loginMethod({
        data: response.data.data.user,
        access_token: response.data.data.access_token
      }))
      navigate("/dashboard/Dashboard")


    } catch (error) {
      setLoading(false)

      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });


    }

  };

  return (
    <section className='h-100  d-flex justify-content-center mt-5 login_form'>
      <ToastContainer />

      <div>
        <div>
          <img src={logo} alt='' />
        </div>
        <div>
          <h4 className='text-center'>مرحباً بعودتك</h4>
          <p className='text-muted'>سجل الدخول للوصول إلى حسابك</p>
        </div>
        <form className='mt-4'>

          {message && String(message)}

          <div className="form-group">
            <label className="mb-1 text-right w-100" style={{ color: "#7e7e7e" }}><strong>الاسم</strong></label>
            <input
              type="text" className="form-control" name="username" value={formData.username} onChange={handleChange}
            />{errors.username && <p style={{ color: "red" }}>{errors.username}</p>}
          </div>
          <div className="form-group position-relative">
            <label className="mb-1  text-right w-100" style={{ color: "#7e7e7e" }}><strong>كلمة المرور</strong></label>
            <input
              type={showPassword ? "text" : "password"} id="dz-password" className="form-control" name="password" value={formData.password} onChange={handleChange}
            />
            <span className="show-pass eye" onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer", position: "absolute", top: "35px", right: "10px" }} > {showPassword ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>} </span> {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
          </div>
          <div className="text-center">
            {
              loading ?

                <div className=" bg-secondary py-2 rounded text-white d-flex align-items-center justify-content-center" onClick={handleSubmit}>
                  <p className='mb-0 mx-1'>
                    تسجيل الدخول
                  </p>
                  <Spinner size='l' />

                </div>

                :

                <div className=" btn-block py-2 rounded text-white" onClick={handleSubmit}style={{cursor:"pointer"}}>تسجيل الدخول</div>

            }

          </div>
          <div className="text-center">

            <Link to='/signup'>
              <div type="submit" className="text-muted text-underline mt-4" style={{
                textDecoration: "underline",
                fontWeight: "600"
              }}>
                أنشئ حسابك              </div>

            </Link>
          </div>
        </form>
      </div>

    </section>
  )
}

export default LoginForm
